import {
  CheckCircle,
  DeleteOutline,
  EditOutlined,
  LockOutlined,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Chip,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import useStyles from "./styles";

// Card de uma conexão (banco ou API). Os segredos nunca chegam ao front:
// só sabemos se estão definidos.
export default function ConexaoCard({
  conexao,
  campos,
  nomePadrao,
  onEditar,
  onExcluir,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Paper
      variant="outlined"
      sx={{ ...styles.conexao, ...(conexao.emUso ? styles.conexaoEmUso : {}) }}
    >
      <Box sx={styles.conexaoHeader}>
        <Box sx={styles.posicao}>#{conexao.posicao}</Box>
        <Typography sx={styles.conexaoNome} noWrap>
          {conexao.descricao || nomePadrao}
        </Typography>
        {conexao.emUso && (
          <Tooltip title="Conexão utilizada pelo servidor neste momento">
            <Chip
              icon={<CheckCircle />}
              label="Em uso"
              size="small"
              sx={styles.chipEmUso}
            />
          </Tooltip>
        )}
        <Box sx={{ flex: 1 }} />
        <Tooltip title="Editar">
          <IconButton size="small" onClick={onEditar}>
            <EditOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Excluir">
          <IconButton size="small" color="error" onClick={onExcluir}>
            <DeleteOutline fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {conexao.erroCriptografia && (
        <Alert severity="warning" sx={styles.conexaoAlerta}>
          Não foi possível ler estes dados com a chave atual
          (ERP_CONFIG_SECRET). Edite a conexão e informe os valores novamente.
        </Alert>
      )}

      <Box sx={styles.campos}>
        {campos.map((campo) => {
          const valor = campo.secreto
            ? conexao.secretosDefinidos?.[campo.chave]
            : conexao.valores?.[campo.chave];
          return (
            <Box
              key={campo.chave}
              sx={campo.tipo === "url" ? styles.campoLargo : styles.campo}
            >
              <Typography sx={styles.campoLabel}>{campo.label}</Typography>
              {campo.secreto ? (
                <Typography
                  sx={valor ? styles.campoSecreto : styles.campoVazio}
                >
                  {valor ? (
                    <>
                      <LockOutlined sx={styles.cadeado} />
                      ••••••••
                    </>
                  ) : (
                    "Não definida"
                  )}
                </Typography>
              ) : (
                <Tooltip title={valor || ""} placement="top-start">
                  <Typography
                    sx={valor ? styles.campoValor : styles.campoVazio}
                    noWrap
                  >
                    {valor || "—"}
                  </Typography>
                </Tooltip>
              )}
            </Box>
          );
        })}
      </Box>

      <Typography sx={styles.conexaoRodape}>
        Atualizado em {dayjs(conexao.updatedAt).format("DD/MM/YYYY [às] HH:mm")}
      </Typography>
    </Paper>
  );
}
